<div>
    <FlashMessage></FlashMessage>
    <div class="view-table">
        <div class="white-box pb-0">

            <div class="table-title">
                <div class="error-list" v-if="ui.error.error_message">
                    <ul class="error-msg">
                        <li :key="x" v-for="(error,x) in ui.error.error_message">
                            <div :key="i" v-for="(err,i) in error">
                                <p> {{err}}</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="container-fluid px-0">
                    <div class="row align-items-center">
                        <div class="col-lg-6" v-if="item.bookingData.trek.title">
                            <h4 class="mb-1">{{item.bookingData.trek.title}}</h4>
                            <div class="depart-date" v-if="item.bookingData.departure.start_date">
                                <p><i class="far fa-calendar-alt"></i> Departure date: <span>{{item.bookingData.departure.start_date}}</span>
                                </p>
                            </div>
                            <div class="depart-date" v-else>
                                <p><i class="far fa-calendar-alt"></i> Departure date: - </p>
                            </div>
                        </div>
                        <div class="col-lg-6" v-else>
                            <h5> - </h5>
                        </div>
                        <div>
                            <a @click.prevent="redirectToBooking" class="btn btn-link btn-sm" href="javascript:void(0)"><i
                                    class="fas fa-arrow-circle-left"></i> Back</a>
                        </div>
                    </div>
                    <div class="manage-booking-table">
                        <div class="container-fluid px-0 pt-2">
                            <div class="row">
                                <div class="col-lg-6">
                                    <!-- <a href="javascript:void(0)" class="btn btn-danger btn-sm" @click.prevent="showBookingModal"><i class="fas fa-times"></i> Cancel this booking</a>
                                    <a href="javascript:void(0)" class="btn btn-success btn-sm"><i class="fas fa-check"></i> Mark as complete</a> -->
                                </div>
                                <div class="col-lg-6">
                                    <div class="top-btn">
                                        <a @click.prevent="downloadPdf" class="btn btn-primary btn-sm"
                                           href="javascript:void(0)"><i class="fas fa-download"></i> Download as pdf</a>
                                        <a @click.prevent="showSendEmailModal" class="btn btn-success btn-sm"><i
                                                class="fas fa-envelope"></i> Send as email</a>
                                        <a class="btn btn-secondary btn-sm" href="javascript:void(0)"><i
                                                class="fas fa-print"></i> Print</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="invoice-heading">
                                    <h5>Invoice to:</h5>
                                    <!-- <p class="mb-0">{{CustomerList}}</p> -->
                                    <p class="mb-0" v-if="item.bookingData.customer.title">
                                        {{item.bookingData.customer.full_name}}</p>
                                    <p class="mb-0" v-else>-</p>
                                    <p class="mb-0" v-if="item.bookingData.customer.email">
                                        {{item.bookingData.customer.email}}</p>
                                    <p class="mb-0" v-else>-</p>
                                    <p class="mb-0" v-if="item.bookingData.customer.created_at">
                                        {{item.bookingData.customer.created_at}}</p>
                                    <p class="mb-0" v-else>-</p>
                                    <p class="mb-0" v-if="item.bookingData.customer.contact_number">
                                        {{item.bookingData.customer.contact_number}}</p>
                                    <p class="mb-0" v-else>-</p>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="invoice-heading" v-if="item.bookingData.account">
                                    <h5>Invoice by:</h5>
                                    <p class="mb-0" v-if="item.bookingData.account.company_name">
                                        {{item.bookingData.account.company_name}}</p>
                                    <p class="mb-0" v-else>-</p>
                                    <p class="mb-0" v-if="item.bookingData.account.company_contact_person">
                                        {{item.bookingData.account.company_contact_person}}</p>
                                    <p class="mb-0" v-else>-</p>
                                    <p class="mb-0"
                                       v-if="item.bookingData.account.company_address_line2 || item.bookingData.account.company_city || item.bookingData.account.company_country">
                                        {{item.bookingData.account.company_address_line2}},
                                        {{item.bookingData.account.company_city}},
                                        {{item.bookingData.account.company_country}}</p>
                                    <p class="mb-0" v-else>-</p>
                                    <p class="mb-0" v-if="item.bookingData.trek.created_at">
                                        {{item.bookingData.trek.created_at}}</p>
                                    <p class="mb-0" v-else>-</p>
                                    <p class="mb-0" v-if="item.bookingData.account.company_zip">
                                        {{item.bookingData.account.company_zip}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="view-detail">
                            <div class="table-container">
                                <div class="col-lg-6">


                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="example">
                                        <thead class="table-light-bg">
                                        <tr>
                                            <th>Particulars
                                            </th>
                                            <th scope="col">Trek details
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="item.bookingData.trek">
                                        <tr class="booking-detail-row">
                                            <td v-if="item.bookingData.total_no_of_travellers">Total number of
                                                travelers:
                                                <span>{{item.bookingData.total_no_of_travellers}}</span></td>
                                            <td v-else>Total number of traveler: -</td>
                                            <td v-if="item.bookingData.trek.title">Package name: <span>{{item.bookingData.trek.title}}</span>
                                            </td>
                                            <td v-else>Package name: -</td>

                                        </tr>
                                        <tr class="booking-detail-row">
                                            <td v-if="item.bookingData.no_of_adult">No. of Adults: <span>{{item.bookingData.no_of_adult}}</span>
                                            </td>
                                            <td v-else>No. of Adults: -</td>
                                            <td v-if="item.bookingData.trek.duration">Duration: <span>{{item.bookingData.trek.duration}}</span>
                                            </td>
                                            <td v-else>Duration: -</td>
                                        </tr>
                                        <tr class="booking-detail-row">
                                            <td v-if="item.bookingData.no_of_youth">No. of Youths: <span>{{item.bookingData.no_of_youth}}</span>
                                            </td>
                                            <td v-else>No. of Youths: -</td>
                                            <td v-if="item.bookingData.account.company_name">Tour operator: <span>{{item.bookingData.account.company_name}}</span>
                                            </td>
                                            <td v-else>Tour operator: -</td>
                                        </tr>
                                        <tr class="booking-detail-row">
                                            <td v-if="item.bookingData.no_of_infant">No. of Infants: <span>{{item.bookingData.no_of_infant}}</span>
                                            </td>
                                            <td v-else>No. of Infants: -</td>
                                            <td>Trip difficulty: Hard</td>
                                        </tr>
                                        <tr class="booking-detail-row-border">
                                            <td class="empty-td"></td>
                                            <td>
                                                <p class="sub-title" v-if="item.subTotal"> Subtotal:$
                                                    <span>{{item.subTotal}}</span></p>
                                                <p class="sub-title" v-else> Subtotal:$ - </p>
                                            </td>
                                        </tr>
                                        <tr class="booking-detail-row">
                                            <td class="empty-td"></td>
                                            <td>
                                                <p class="sub-title" v-if="item.bookingData.saved_price"> Discount: $
                                                    <span>{{item.bookingData.saved_price}}</span>
                                                </p>
                                                <p class="sub-title" v-else> Discount: $ 0.00</p>

                                            </td>
                                        </tr>
                                        <!-- <tr class="booking-detail-row">
                                          <td class="empty-td"></td>
                                          <td>
                                              <p class="sub-title"> Tax:2.5% </p>

                                          </td>
                                        </tr> -->
                                        <tr class="booking-detail-row-border">
                                            <td class="empty-td"></td>
                                            <td v-if="item.bookingData.total_price">
                                                <h4>Total amount: <span>$ {{item.bookingData.total_price}}</span></h4>
                                            </td>
                                            <td v-else>
                                                <h4>Total amount: <span>$ 0.00</span></h4>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="modal-wrap">
                <!-- Modal -->
                <div
                        aria-hidden="true"
                        aria-labelledby="exampleModalLabel"
                        class="modal fade"
                        id="sendemail"
                        role="dialog"
                        tabindex="-1"
                >
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Send email</h5>
                                <button
                                        @click.prevent="hideSendEmailModal"
                                        aria-label="Close"
                                        class="close"
                                        type="button"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="error-list" v-if="ui.error.modal.email">
                                    <ul class="error-msg">
                                        <li :key="x" v-for="(error,x) in ui.error.modal.email">
                                            <div :key="i" v-for="(err,i) in error">
                                                <p>{{err}}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-modified">
                                    <div class="form-wrap">
                                        <div class="form-group">
                                            <label for="">Enter email address</label>
                                            <input
                                                    :class="{ 'error-input' : ui.error.errors['email'] }"
                                                    class="form-control"
                                                    placeholder="Email address"
                                                    type="text"
                                                    v-model="item.emailData"
                                            />
                                        </div>
                                        <validation-error :errors="ui.error.errors" :field="'email'"
                                                          :isError="ui.error.has_error"
                                                          v-if="ui.error.has_error"/>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                        :disabled="ui.status.sendEmail"
                                        @click.prevent="sendEmailAction"
                                        class="btn default-btn"
                                        type="button"
                                >{{buttonTextSendEmail}}
                                    <spinner :loading="ui.status.postLoading" v-if="ui.status.postLoading"></spinner>
                                </button>
                                <button
                                        @click.prevent="hideSendEmailModal"
                                        class="btn default-btn cancel"
                                        type="button"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-wrap">
                <div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade show"
                     data-backdrop="static"
                     data-keyboard="false" id="cancelBooking" role="dialog"
                     tabindex="-1">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Delete Departure</h5>
                                <button @click.prevent="cancelBookingModal" aria-label="Close" class="close" type="button">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <!-- <div class="error-list" v-if="errorsEdit">
                              <ul class="error-msg">
                                <li v-for="(error,x) in errorsEdit" :key="x">
                                  <div v-for="(err,i) in error" :key="i">
                                    <p> {{err}}</p>
                                  </div>
                                </li>
                              </ul>
                            </div> -->
                            <div class="modal-body">
                                <p>Are you sure you want to delete this ?</p>
                            </div>

                            <div class="modal-footer">
                                <button @click.prevent="cancelBookingModal" class="btn default-btn" type="button">Ok</button>
                                <button @click.prevent="cancelBookingModal" class="btn default-btn cancel" type="button">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
